import React, { useState } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import Spinner from '@features/ui/Spinner';
import TicketRuleAbnormal from '@features/TicketRuleAbnormal';
import { I_MiniRuleInfo, I_OtherPenaltyDetail } from '@Redux/confirmation/interfaces';
// import { sortData } from "@utils/utils"


interface I_TicketRuleLCCProps {
    Rtow: number | string;
    miniRule: {
        data?: I_MiniRuleInfo[];
        isLoading?: boolean;
    };
}
interface I_Detail {
    code: string;
    name: string;
    desc: string;
    subName: string[];
    subDesc: string[];
}

// todo 如果有箭頭符號 div 改成 pre

//廉價航空票規樣式
const TicketRuleLCC = ({ Rtow, miniRule }: I_TicketRuleLCCProps) => {
    const moduleName = 'ticketRule';
    const miniRuleData = miniRule?.data;
    const miniRuleIsLoading = miniRule?.isLoading;

    if (miniRuleIsLoading) return <Spinner />;
    if (!miniRuleData) return <TicketRuleAbnormal />;

    let checkMiniRuleHasInfo = false
    if (miniRuleData) {
        let MiniRuleAbnormal = true;
        miniRuleData.forEach((info: any) => {
            if (!info?.PenaltyInfo && !info?.FareFamilyPenaltyDetail && info?.OtherPenaltyDetail.length === 0) MiniRuleAbnormal = false
        })
        checkMiniRuleHasInfo = MiniRuleAbnormal
    }
    if (!checkMiniRuleHasInfo) return <TicketRuleAbnormal />;

    const [curTabIndex, setCurTabIndex] = useState(0);

    const orderOtherPenaltyDetail = miniRuleData?.map((rule) => {
        if (!rule.OtherPenaltyDetail) return []

        const luggage: I_Detail = { code: "", name: "行李", desc: "", subName: [], subDesc: [] }

        return rule.OtherPenaltyDetail.map(((otherRule) => {
            // 特別處理行李的資料
            // if (otherRule.code === "H" || otherRule.code === "I") {
            //     luggage.subName.push(otherRule.name)

            // 手提、托運行李放進行李裡
            //     if (otherRule.TicketRuleDescs[0].Desc) luggage.subDesc.push(otherRule.TicketRuleDescs[0].Desc)
            //     if (luggage.subName.length >= 1) return luggage
            // }
            return ({ code: otherRule.code, name: otherRule.name, desc: otherRule.TicketRuleDescs[0].Desc, subName: [], subDesc: [] })
        }))
    })


    return (
        <>
            {Rtow === "1" && (
                <ul className={styles.typeBtn}>
                    <li
                        className={cN({
                            [`${styles['active']}`]: curTabIndex === 0,
                        })}
                        onClick={() => setCurTabIndex(0)}
                    >
                        查看去程
                    </li>
                    <li
                        className={cN({
                            [`${styles['active']}`]: curTabIndex === 1,
                        })}
                        onClick={() => setCurTabIndex(1)}
                    >
                        查看回程
                    </li>
                </ul>
            )}

            {miniRuleData &&
                miniRuleData.map((rule, i) => (
                    <div
                        key={i}
                        className={cN(moduleName, styles[`${moduleName}`], {
                            [`${styles.hide}`]: i !== curTabIndex,
                        })}
                    >
                        {orderOtherPenaltyDetail[i] &&
                            orderOtherPenaltyDetail[i].map((detail) => {
                                return (
                                    // 一行兩格的格式
                                    // <div className={styles.col} key={detail.name}>
                                    //     <div className={styles.title}>{detail.name}</div>
                                    //     <div className={styles.content}>
                                    //         {detail.subName.map((info, i: number) => {
                                    //             return (
                                    //                 <div key={i} className={styles.subcol}>
                                    //                     <div className={styles.subtitle}>{detail.subName[i]}</div>
                                    //                     <div className={styles.subcontent}>
                                    //                         <div
                                    //                             dangerouslySetInnerHTML={{
                                    //                                 __html: detail.subDesc[i]
                                    //                                     ? detail.subDesc[i]
                                    //                                     : '依航空公司規定',
                                    //                             }}
                                    //                         />
                                    //                     </div>
                                    //                 </div>
                                    //             )
                                    //         })}
                                    //     </div>
                                    // </div>
                                    <div className={styles.col} key={detail.name}>
                                        <div className={styles.title}>{detail.name}</div>
                                        <div className={styles.content}>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: detail.desc
                                                        ? detail.desc
                                                        : '依航空公司規定',
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                                // }
                            })}
                    </div>
                ))}
        </>
    );
};

export default TicketRuleLCC;
